<template>
	<div class="header-container">
		<nav class="navbar navbar-default navbar-fixed-top">
			<div class="navbar-container">
				<div class="logo"><router-link to='/'><img :src="$helper.get('rule').app_logo" alt=""></router-link></div>
				<el-menu :default-active="$route.path" :router="true" :unique-opened="true" mode="horizontal"
					class="navbar-horizontal">
					<el-menu-item index="/">
						{{ $t('主页') }}
					</el-menu-item>
					<el-menu-item index="/category">
						{{$t('商品列表')}}
					</el-menu-item>
					<el-menu-item index="/activity-center">
						{{$t('活动中心')}}
					</el-menu-item>
					<el-menu-item  index="/agency">
						{{$t('团队代理')}}
					</el-menu-item>
					<el-menu-item  index="/about">
						{{$t('关于我们')}}
					</el-menu-item>
				</el-menu>
				<div class="nav-search" v-if="$store.state.isLoginStatu && $store.state.userInfo">
					<el-input :placeholder="$t('请输入搜索内容')" v-model="keyword">
						<button slot="suffix" class="btn btn-so" @click="onSearch">
							<span class="iconfont icon-so"></span>
						</button>
					</el-input>
				</div>
				<div class="nav-right" >
					<el-dropdown v-if="$store.state.isLoginStatu && $store.state.userInfo">
						<div class="user-dropdown-link">
							<img :src="$store.state.userInfo.avatar && $store.state.userInfo.avatar != '' ? $store.state.userInfo.avatar : require('@/assets/images/head.png')" alt="" />
							<i class="el-icon-arrow-down el-icon--right"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<router-link class="m-link" to="/ucenter">
									<span class="iconfont icon-user1"></span><span>{{$t('个人中心')}}</span>
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link class="m-link" to="/my-order">
									<span class="iconfont icon-dingdan"></span><span>{{$t('我的订单')}}</span>
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link class="m-link" to="/history">
									<span class="iconfont icon-liulanjilu3"></span><span>{{$t('商品浏览记录')}}</span>
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link class="m-link" to="/address">
									<span class="iconfont icon-ditu"></span><span>{{$t('地址管理')}}</span>
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<div class="m-link" @click="loginOut">
									<span class="iconfont icon-ai-out"></span><span>{{$t('退出')}}</span>
								</div>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<ul class="nav-menu nav-enter-menu" v-else>
						<li>
							<router-link to="/Login">
								<span class="iconfont icon-user"></span><span class="enter-item">{{$t('登录')}}</span>
							</router-link>
						</li>
						<li>
							<router-link to="/Register">
								<span class="iconfont icon-invte"></span><span class="enter-item">{{$t('注册')}}</span>
							</router-link>
						</li>
					</ul>
					<ul class="nav-menu nav-menu-link" >
						<li v-if="$store.state.isLoginStatu && $store.state.userInfo">
							<router-link to="/favorite">
								<span class="iconfont icon-collect-solid"></span>
							</router-link>
						</li>
						<li >
							<router-link to="/cart">
								<span class="dot" v-if="$store.state.CartNumber && $store.state.CartNumber > 0"></span>
								<span class="iconfont icon-cart"></span>
							</router-link>
							<span class="cart-dot" :class="{active: $store.state.isAddCart}"></span>
						</li>
						<li v-if="!$store.state.isLoginStatu ">
							<router-link to="/my-order">
								<span class="iconfont icon-order"></span>
							</router-link>
						</li>
					</ul>
					<el-dropdown @command="handleCommand" v-if="langType">
						<div class="dropdown__trigger dropdown__langType">
							<img :src="getFlagImage(langType)" alt="" />
							<i class="el-icon-arrow-down el-icon--right"></i>
						</div>
						<el-dropdown-menu slot="dropdown" class="dropdown-menu_md lan-dropdown">
							<el-dropdown-item :command="item" v-for="(item,index) in langArr" :key="`langArr${index}`">
								<div class="dropdown-menu__link">
									<span v-if="item.lang == 'us'">
										{{$t('EN')}}
									</span>
									<span class="text" v-else>
										{{$t(item.lang)}}
									</span>
								</div>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</nav>
	</div>
</template>
<script>
	import helper from '@/common/helper.js';
	import {
		user_login_out_api
	} from "@/api/user"
	export default {
		props: {
			topNav: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			langArr() {
				let _this = this;
				let options = [];
				let selecValue = this.$helper.getLang();
				let all_lang = this.$helper.get("alllang");
				if (all_lang != null) {
					for (let i = 0; i < all_lang.length; i++) {
						options.push(all_lang[i]);
						if (selecValue == all_lang[i].lang) {
							_this.currentSelect = all_lang[i];
						}
					}
				}
				return options;
			},
		},
		data() {
			return {
				keyword: "",
				langType: "",
				myData:{},
				agencyNav:null,
				aboutNav:null
			};
		},
		watch: {},
		mounted() {
			this.langChange()
			if(helper.get("vuexSetCartNumber") && helper.get("vuexSetCartNumber") != ""){
				this.$store.commit("$vuexSetCartNumber", this.$helper.get("vuexSetCartNumber"));
			}
		},
		methods: {
			getFlagImage(langType) {
			  return require(`@/assets/images/${langType}.png`)
			},
			handleCommand(command) {
				this.langType = command.lang;
				this.$helper.setLang(command.lang);
				this.$i18n.locale = command.lang;
				window.location.reload();
				this.$router.go(0);
			},
			langChange() {
				// this.langIcon = this.$helper.get("i18n_icon");
				this.langType = this.$helper.get("i18n_lang");
			},
			async loginOut() {
				await user_login_out_api().then(res => {
					if (res && res.data.code == 1) {
						this.$helper.rm("tokenInfo");
						this.$helper.rm("userInfo");
						this.$helper.rm("CartNumber");
						this.$helper.rm("expirationTime");
						this.$store.commit("$vuexSetLoginState", false);
						this.$store.commit("$vuexUserInfo", null);
						this.$message({
							customClass: "successMessage",
							showClose: false,
							message: this.$t("已成功退出当前账号"),
							center: true,
							type: "success",
							duration: "1000",
							onClose: () => {
								this.goUrl('/');
								window.location.reload();
							}
						});
					} else if(res && res.data.code == -1){
						this.$helper.rm("tokenInfo");
						this.$helper.rm("userInfo");
						this.$store.commit("$vuexSetLoginState", false);
						this.$store.commit("$vuexUserInfo", null);
						this.goUrl('/login');
					}
					else {
						this.errorTips("失败");
					}
				});
			},
			onSearch(){
				if (this.keyword == "") {
					this.errorTips("请输入搜索内容");
					return false;
				}
				this.$router.push({
				  path: '/category', 
				  query: {
					  keyword: this.keyword,
				  }
				})
			}
			
		}
	}
</script>
<style scoped>
	.dropdown__langType{
		display: flex;
		align-items: center;
		margin-left: 15px;
	}
	.dropdown__langType img{
		width: 30px;
		height: 20px;
	}
	.el-menu.el-menu--horizontal {
		border-bottom: 0;
	}

	.navbar-horizontal {
		margin-left: 20px;
	}

	.navbar-horizontal>.el-menu-item {
		color: #333;
		font-size: 16px;
		height: 50px;
		line-height: 50px;
		padding: 0 10px;
		margin: 0 6px;
	}

	.navbar-horizontal>.el-menu-item.is-active {
		border-bottom: 2px solid #a7761f;
		color: #a7761f;
	}

	.user-dropdown-link {
		display: flex;
		align-items: center;
	}

	.user-dropdown-link img {
		width: 36px;
		height: 36px;
		border-radius: 40px;
	}
	.m-link{
		display: block;
		line-height: 36px;
	}
	.m-link .iconfont{
		margin-right: 8px;
	}
	.nav-menu-link > li{
		position: relative;
	}
	.cart-dot{
		width: 10px;
		height: 10px;
		background-color: #FD7666;
		display: inline-block;
		border-radius: 10px;
		position: absolute;
		top: -12px;
		left: 50%;
		margin-left: -5px;
		opacity: 0;
	}
	.cart-dot.active {
		animation: dot .6s;
	}
	@keyframes dot{
	  0%{
	    transform: translateY(0);
		opacity: 1;
	  }100%{
	    transform: translateY(10px);
		opacity: 0;
	  }
	}
	

	@media (max-width:1600px) {
		.navbar-horizontal {
			margin-left: 0;
		}

		.navbar-horizontal>.el-menu-item {
			margin: 0 5px;
			font-size: 15px;
		}

		.nav-menu-link {
			margin-left: 20px;
		}
	}

	@media (max-width:1400px) {
		.navbar-horizontal>.el-menu-item {
			font-size: 14px;
		}
		.navbar-default {
			padding: 0 20px;
		}

		.navbar-horizontal>.el-menu-item {
			margin: 0 5px;

		}

		.nav-menu-link {
			margin-left: 10px;
		}
	}
</style>